import GraphContainer from "./graph_container";

function createLabelFilter(uuid) {
    const feFlood = GraphContainer
        .create("feFlood")
        .setAttribute("flood-color", "black");

    const feGaussianBlur = GraphContainer
        .create("feGaussianBlur")
        .setAttribute("stdDeviation", 2);

    const feComponentTransfer1 = GraphContainer
        .create("feComponentTransfer")
        .append(
            GraphContainer
                .create("feFuncA")
                .setAttribute("type", "table")
                .setAttribute("tableValues", "0 0 0 1")
        );

    const feComponentTransfer2 = GraphContainer
        .create("feComponentTransfer")
        .setAttribute("result", "roundedRect")
        .append(
            GraphContainer
                .create("feFuncA")
                .setAttribute("type", "table")
                .setAttribute("tableValues", "0 1 1 1 1 1 1 1")
        );

    const feComposite = GraphContainer
        .create("feComposite")
        .setAttribute("operator", "over")
        .setAttribute("in", "SourceGraphic")
        .setAttribute("in2", "roundedRect");

    const filter = GraphContainer
        .create("filter")
        .setAttribute("x", "-10%")
        .setAttribute("y", "-10%")
        .setAttribute("width", "120%")
        .setAttribute("height", "120%")
        .setAttribute("id", `fill_text_${uuid}`)
        .append(feFlood, feGaussianBlur, feComponentTransfer1, feComponentTransfer2, feComposite);

    return { feFlood, filter };
}

export default createLabelFilter;
export { createLabelFilter };